module.exports = __webpack_public_path__ + "img/benlose_fugle2.d0e8b13c.jpg";